import React from 'react';
import { CheckCircle2, Circle, AlertCircle } from 'lucide-react';
import { useLanguage } from 'lib/i18n';

const STEPS = [
  { key: 'pending', label: 'timeline.pending' },
  { key: 'accepted', label: 'timeline.accepted' },
  { key: 'in_progress', label: 'timeline.prepared' },
  { key: 'picked_up', label: 'timeline.pickedUp' },
  { key: 'in_transit', label: 'timeline.inTransit' },
  { key: 'arrived_relay', label: 'timeline.relay' },
  { key: 'delivered', label: 'timeline.delivered' },
];

const getIndex = (status) => STEPS.findIndex(s => s.key === status);

export const StatusTimeline = ({ status, history = [] }) => {
  const { language, t } = useLanguage();
  const currentIdx = getIndex(status);
  const isDispute = status === 'dispute';
  const isCancelled = status === 'cancelled';

  return (
    <div className="space-y-4" data-testid="status-timeline">
      {isCancelled && (
        <div className="flex items-center gap-2 p-3 rounded-lg bg-gray-100 text-gray-700">
          <AlertCircle size={18} /> {t('timeline.cancelled')}
        </div>
      )}
      {isDispute && (
        <div className="flex items-center gap-2 p-3 rounded-lg bg-red-50 text-red-700 border border-red-200">
          <AlertCircle size={18} /> {t('timeline.dispute')}
        </div>
      )}
      <ol className="relative space-y-3">
        {STEPS.map((step, idx) => {
          const done = currentIdx >= idx && !isCancelled;
          const current = currentIdx === idx && !isCancelled;
          const entry = history.find(h => h.status === step.key);
          return (
            <li key={step.key} className="flex gap-3 items-start">
              <div className="relative flex flex-col items-center">
                {done ? (
                  <CheckCircle2 size={22} className={current ? 'text-primary' : 'text-emerald-600'} />
                ) : (
                  <Circle size={22} className="text-muted-foreground/40" />
                )}
                {idx < STEPS.length - 1 && (
                  <span className={`w-px flex-1 my-1 h-6 ${done ? 'bg-primary/60' : 'bg-border'}`} />
                )}
              </div>
              <div className="flex-1 pb-2">
                <div className={`font-medium text-sm ${current ? 'text-primary' : done ? 'text-foreground' : 'text-muted-foreground'}`}>
                  {t(step.label)}
                </div>
                {entry && (
                  <div className="text-xs text-muted-foreground mt-0.5">
                    {new Date(entry.at).toLocaleString(language === 'en' ? 'en-GB' : 'fr-FR')}
                    {entry.note && <> • {entry.note}</>}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
